export const folderIsJudiciary = (relatedFolder: Record<string, any>): boolean =>
  relatedFolder && relatedFolder.type === 'judiciary';

export const courtIsPublicAuthority = (courtName: string | undefined): boolean =>
  courtName?.toLowerCase() === 'ente pubblico';
